import { Link } from 'react-router-dom';
import { CheckCircle, Home, ShoppingBag } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const ConfirmationPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-[color:var(--color-bg)] pt-24 pb-16 flex items-center justify-center">
      <div className="max-w-lg mx-auto px-4 text-center">
        <div className="w-20 h-20 mx-auto mb-6 bg-[#4ADE80]/10 rounded-full flex items-center justify-center">
          <CheckCircle className="w-10 h-10 text-[#4ADE80]" />
        </div>
        
        <h1 
          className="text-4xl text-white font-light mb-4"
          style={{ fontFamily: 'Cormorant Garamond, serif' }}
        >
          {t('confirmation_title')}
        </h1>
        
        <p className="text-zinc-400 mb-8 leading-relaxed">
          {t('confirmation_desc')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" className="btn-outline flex items-center justify-center gap-2">
            <Home className="w-4 h-4" />
            {t('nav_home')}
          </Link>
          <Link to="/catalogue" className="btn-primary flex items-center justify-center gap-2">
            <ShoppingBag className="w-4 h-4" />
            {t('cart_continue_shopping')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationPage;
